<article class="query-table">
	<stages-media-switch>
		<!-- Wait for query -->
		@if (isRunning && !error) {
			<div class="query">
				<div class="query-error">
					<stages-spin size="sm"></stages-spin>
					<div>
						<span class="h3" translate="query.waiting"></span>
					</div>
				</div>
			</div>
		}

		@if (status.resolved) {
			<div>
				@if (!error) {
					<div>
						@if (table) {
							<div>
								<!-- Mobile View -->
								<ul class="grouped-list" *stagesMediaDefault>
									@for (header of table.headers; track header; let i = $index) {
										<li class="group">
											<header class="group-header">
												<span class="h3" (click)="toggle(i)" [title]="header?.hover ? header.hover : ''">{{ header.text }}</span>
												<stages-button-expand-collapse
													[classes]="'action menu-button'"
													[isCollapsed]="!isOpen(i)"
													(pressedButton)="toggle(i)"
												></stages-button-expand-collapse>
											</header>
											@if (isOpen(i)) {
												<div class="relative-container">
													<div class="animation-container">
														<div class="expandable">
															<ul class="list dense last">
																@for (row of table.data; track trackByIndex($index, row)) {
																	<li class="list-item" [title]="row[i].hover ? row[i].hover : ''">
																		@if (row[i]) {
																			<div class="label">
																				<div class="text">
																					<span class="h4">
																						@switch (row[i].type) {
																							@case ("LINK") {
																								<a [href]="row[i].link" target="_blank" rel="noopener noreferrer">{{
																									row[i].text
																								}}</a>
																							}
																							@case ("IMAGE") {
																								<img [src]="row[i].link" alt="{{ row[i].text }}" />
																							}
																							@default {
																								<span>{{ row[i].text }}</span>
																							}
																						}
																					</span>
																				</div>
																			</div>
																		}
																	</li>
																}
															</ul>
														</div>
													</div>
												</div>
											}
										</li>
									}
								</ul>
								<!-- Web View -->
								<div *stagesMediaCase="Size.XSMALL">
									<div class="query-input">
										@if (table.showFilter) {
											<input
												id="filterText"
												name="filterText"
												type="text"
												class="text"
												(keyup)="applyFilter($any($event.target).value)"
												placeholder="{{ 'query.filter' | translate }}"
											/>
										}
										@if (table.showExport) {
											<button class="sm" (click)="exportAsExcel()" translate="query.export"></button>
										}
									</div>
									<div class="query-table-container">
										<table
											mat-table
											[dataSource]="sortedTableData"
											matSort
											(matSortChange)="sortData($event)"
											class="table dense"
										>
											@for (header of table.headers; track header; let i = $index) {
												<ng-container [matColumnDef]="header.text">
													<th
														mat-header-cell
														*matHeaderCellDef
														[mat-sort-header]="header.text"
														[title]="header?.hover ? header.hover : ''"
													>
														{{ header.text }}
													</th>
													<td mat-cell *matCellDef="let data" [title]="data[i]?.hover ? data[i].hover : ''">
														@if (data[i]) {
															@switch (data[i].type) {
																@case ("LINK") {
																	<a [href]="data[i].link" target="_blank">{{ data[i].text }}</a>
																}
																@case ("IMAGE") {
																	<img [src]="data[i].link" alt="{{ data[i].text }}" />
																}
																@default {
																	<span>{{ data[i].text }}</span>
																}
															}
														}
													</td>
												</ng-container>
											}
											<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
											<tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
										</table>
									</div>
								</div>
							</div>
						}
						@if (!table) {
							<p class="empty"></p>
						}
					</div>
				}
				@if (error) {
					<div class="query">
						<div class="query-error">
							<div>
								<i class="ico ico-warning"></i>
							</div>
							<span class="h3" translate="query.error"></span>
							<span class="reason">{{ error }}</span>
						</div>
					</div>
				}
			</div>
		}
	</stages-media-switch>
</article>

